<template>
<!-- 提现审核 -->
  <div>
    <div class="action">
      <el-checkbox v-model="hideZero">隐藏余额为0的币种</el-checkbox>
      <div class="back">
       <span class="invitestyle">邀请返佣金额总计：{{ invite.hyRewards + invite.xhRewards}}USDT</span>
       <span class="invitestyle">合约返佣：{{invite.hyRewards}} USDT</span>
       <span class="invitestyle">现货手续费返佣+活期宝返佣：{{invite.xhRewards}} USDT</span>
      </div>
    </div>
    <el-table :data="userWallet | filterList(hideZero)">
      <el-table-column prop="coinType" label="币种">
      </el-table-column>
      <el-table-column prop="currentInterest" label="活期利息">
      </el-table-column>
      <el-table-column label="C2C买入/卖出">
        <template slot-scope="scope">{{scope.row.c2cBuy}}/{{scope.row.c2cSell}}</template>
      </el-table-column>
      <el-table-column label="OTC买入/卖出">
        <template slot-scope="scope">{{scope.row.otcBuy}}/{{scope.row.otcSell}}</template>
      </el-table-column>
      <el-table-column label="充值/提现">
        <template slot-scope="scope">{{scope.row.deposit}}/{{scope.row.withdrawal}}</template>
      </el-table-column>
      <el-table-column label="(站内)充值/提现">
        <template slot-scope="scope">{{scope.row.internalDeposit}}/{{scope.row.internalWithdrawal}}</template>
      </el-table-column>
      <el-table-column label="合约买入/卖出">
        <template slot-scope="scope">{{scope.row.contractBuy}}/{{scope.row.contractSell}}</template>
      </el-table-column>
      <el-table-column label="WALLET可用/冻结">
        <template slot-scope="scope">{{scope.row.coinAmount}}/{{scope.row.coinFroze}}</template>
      </el-table-column>
      <el-table-column label="OTC可用/冻结">
        <template slot-scope="scope">{{scope.row.otcCoinAmount}}/{{scope.row.otcCoinFroze}}</template>
      </el-table-column>
      <el-table-column label="超级合约可用/冻结">
        <template slot-scope="scope">{{scope.row.generalAvailableAmount}}/{{scope.row.generalFrozeAmount}}</template>
      </el-table-column>
      <el-table-column label="超级合约盈亏" prop="generalProfit"/>
      <el-table-column label="合约可用/冻结">
        <template slot-scope="scope">{{scope.row.contractAvailableAmount}}/{{scope.row.contractFrozeAmount}}</template>
      </el-table-column>
        <el-table-column label="跟单可用/冻结">
                  <template slot-scope="scope">{{scope.row.followAvailableAmount}}/{{scope.row.followFrozeAmount}}</template>
              </el-table-column>
      <el-table-column prop="totalAmount" label="总量"/>
    </el-table>
  </div>

</template>

<script>
import { mapState } from 'vuex';
import api from '../../api';
export default {
  data() {
    return {
      hideZero: true,
      contract:0,
      service:0,
      current:0,
      total:0,
    };
  },
  computed: {
    ...mapState('withdrawalAudit', ['userWallet','invite'])
  },
  created(){
    
  },
  filters: {
    filterList: (value, isHide) => {
      return value.filter(item => (isHide ? ((item.currentInterest !== 0) || (item.c2cBuy !== 0) || (item.c2cSell !== 0) || (item.deposit !== 0)
              || (item.withdrawal !== 0) || (item.coinAmount !== 0) || (item.coinFroze !== 0) || (item.totalAmount !== 0))
              || (item.internalDeposit !== 0) || (item.internalWithdrawal !== 0)
              || (item.otcCoinAmount !== 0) || (item.otcCoinFroze !== 0) || (item.generalAvailableAmount !== 0) || (item.generalFrozeAmount !== 0)
              || (item.contractAvailableAmount !== 0 || (item.contractFrozeAmount !== 0)) || item.generalProfit !== 0 : true));
    }
  }
};
</script>

<style scoped lang="less">
.action {
  display: flex;
  padding-bottom: 20px;
}
.invitestyle{
    margin-left:15px;
    color: #409EFF;
}
.back{
  >span{
    display: block;
  }
}
</style>
